"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteSermonEndpoint = exports.publishSermonEndpoint = exports.editSermonEndpoint = exports.addSermonEndpoint = exports.SuccessFailureValidator = exports.sermonTypesEndpoint = exports.sermonSpeakersEndpoint = exports.sermonsEndpoint = void 0;
var t = __importStar(require("typed-validators"));
var routes_1 = require("~shared/utils/routes");
// Sermons
var SermonValidator = t.object({
    optional: {
        id: t.number(),
        mp3: t.oneOf(t.string(), t.null())
    },
    required: {
        date_of_sermon: t.string(),
        title: t.string(),
        speaker: t.string(),
        type_of_sermon: t.string(),
        bible_source: t.string(),
        verses: t.string(),
        verse_of_the_week: t.string(),
        published: t.boolean()
    }
});
var SermonsQueryValidator = t.object({});
var SermonsValidator = t.array(SermonValidator);
var SermonsReturnValidator = t.oneOf(t.object({
    status: t.string('failure')
}), t.object({
    status: t.string('success'),
    sermons: SermonsValidator
}));
exports.sermonsEndpoint = routes_1.asStandardEndpoint({
    apiPath: '/content/sermons',
    method: 'post',
    requestBody: SermonsQueryValidator,
    responseBody: SermonsReturnValidator
});
// SermonSpeakers
var SermonSpeakersQueryValidator = t.object({});
var SermonSpeakersValidator = t.array(t.object({
    name: t.string(),
    n: t.number()
}));
var SermonSpeakersReturnValidator = t.oneOf(t.object({
    status: t.string('failure')
}), t.object({
    status: t.string('success'),
    speakers: SermonSpeakersValidator
}));
exports.sermonSpeakersEndpoint = routes_1.asStandardEndpoint({
    apiPath: '/content/speakers',
    method: 'post',
    requestBody: SermonSpeakersQueryValidator,
    responseBody: SermonSpeakersReturnValidator
});
// sermon types
var SermonTypesQueryValidator = t.object({});
var SermonTypesValidator = t.array(t.object({
    name: t.string(),
    n: t.number()
}));
var SermonTypesReturnValidator = t.oneOf(t.object({
    status: t.string('failure')
}), t.object({
    status: t.string('success'),
    types: SermonTypesValidator
}));
exports.sermonTypesEndpoint = routes_1.asStandardEndpoint({
    apiPath: '/content/sermonTypes',
    method: 'post',
    requestBody: SermonTypesQueryValidator,
    responseBody: SermonTypesReturnValidator
});
// Add Sermon
exports.SuccessFailureValidator = t.object({
    message: t.string(),
    success: t.boolean()
});
var AddSermonQueryValidator = SermonValidator;
exports.addSermonEndpoint = routes_1.asStandardEndpoint({
    apiPath: '/content/addSermon',
    method: 'post',
    requestBody: AddSermonQueryValidator,
    responseBody: exports.SuccessFailureValidator
});
// Edit Sermon
var EditSermonQueryValidator = SermonValidator;
exports.editSermonEndpoint = routes_1.asStandardEndpoint({
    apiPath: '/content/editSermon',
    method: 'post',
    requestBody: EditSermonQueryValidator,
    responseBody: exports.SuccessFailureValidator
});
// publish Sermon
var PublishSermonQueryValidator = t.object({
    id: t.number(),
    published: t.boolean()
});
exports.publishSermonEndpoint = routes_1.asStandardEndpoint({
    apiPath: '/content/publishSermon',
    method: 'post',
    requestBody: PublishSermonQueryValidator,
    responseBody: exports.SuccessFailureValidator
});
// delete Sermon
var DeleteSermonQueryValidator = t.object({ id: t.number() });
exports.deleteSermonEndpoint = routes_1.asStandardEndpoint({
    apiPath: '/content/deleteSermon',
    method: 'post',
    requestBody: DeleteSermonQueryValidator,
    responseBody: exports.SuccessFailureValidator
});
//# sourceMappingURL=sermons.js.map